import * as Yup from "yup";
import { validatePassword } from "../common";

export const singupSchema = Yup.object().shape({
  password: validatePassword,
});
